module.exports = __webpack_public_path__ + "static/19-3b847e7dc07d7c9797e2526f6cc0ee86.jpg";